import ListingVM from './listing-vm';
export default {
  init: function(node){
    //Following options explained here: https://github.com/Knockout-Contrib/Knockout-Validation/wiki/Configuration
    var validationOptions = {
      insertMessages: false,
      errorsAsTitle: true,
      decorateInputElement: true,
      parseInputAttributes: true,
      messagesOnModified: true,
      errorElementClass: 'error',
      errorMessageClass: 'error',
      decorateElementOnModified: true,
      decorateElement: true,
      grouping: { deep: true, observable: true, live: true }
    };

    var terms_data = JSON.parse($('#terms_json').val());
    _.each(terms_data.terms,function(term){
      term.end_date_string = moment(term.end_date_string).format(Kadenze.I18n.t('date.formats.js_default_with_zone'));
      term.start_date_string = moment(term.start_date_string).format(Kadenze.I18n.t('date.formats.js_default_with_zone'));
    });
    ko.applyBindingsWithValidation(new ListingVM(terms_data), node, validationOptions);
  }
};
